import {
    Card,
    CardStrikethrough,
    Dispute,
    GenericCurrency,
    SpeechBubbleWithCross,
    SpeechBubbleWithTick,
    Statement,
    StatementStrikethrough,
} from '@apigrowfinance/pbolt-icons';

export type TimelineItemIconFactoryProps = {
    type: string;
    category: string;
};

const TimelineItemIconFactory = ({
    type,
    category,
}: TimelineItemIconFactoryProps) => {
    let chosenIcon;

    // first give the timeline item a default icon based on it's type
    switch (type) {
        case 'STATEMENT':
            chosenIcon = <Statement fontSize="inherit" />;
            break;
        case 'TRANSACTION':
            chosenIcon = <GenericCurrency fontSize="inherit" />;
            break;
        case 'CONFIRMATION':
            chosenIcon = <GenericCurrency fontSize="inherit" />;
            break;
        case 'CASHIN':
            chosenIcon = <GenericCurrency fontSize="inherit" />;
            break;
        case 'CARD':
            chosenIcon = <Card fontSize="inherit" />;
            break;
        default:
            chosenIcon = null;
            break;
    }

    // we have a list of icons for various category types, so if there is a more specific one, find it here
    switch (category) {
        case 'OVERDUE':
            chosenIcon = <Statement fontSize="inherit" />;
            break;
        case 'CLOSE':
            chosenIcon = <StatementStrikethrough fontSize="inherit" />;
            break;
        case 'CARD_BLOCK':
            chosenIcon = <CardStrikethrough fontSize="inherit" />;
            break;
        case 'PAYMENT':
            chosenIcon = <Statement fontSize="inherit" />;
            break;
        case 'PARTIAL_PAYMENT':
            chosenIcon = <Statement fontSize="inherit" />;
            break;
        case 'CREATE':
            chosenIcon = <Dispute fontSize="inherit" />;
            break;
        case 'LIMIT_NEAR':
            chosenIcon = <GenericCurrency fontSize="inherit" />;
            break;
        case 'LIMIT_REACHED':
            chosenIcon = <GenericCurrency fontSize="inherit" />;
            break;
        case 'AUTHORIZE':
            chosenIcon = <SpeechBubbleWithTick fontSize="inherit" />;
            break;
        case 'CANCELLATION':
            chosenIcon = <SpeechBubbleWithCross fontSize="inherit" />;
            break;
        case 'REFUSAL':
            chosenIcon = <SpeechBubbleWithCross fontSize="inherit" />;
            break;
        case 'CREATION':
            chosenIcon = <Card fontSize="inherit" />;
            break;
        case 'PRODUCTION':
            chosenIcon = <Card fontSize="inherit" />;
            break;
        case 'DELIVERY':
            chosenIcon = <Card fontSize="inherit" />;
            break;
        case 'ACTIVATION':
            chosenIcon = <Card fontSize="inherit" />;
            break;
        case 'BLOCK':
            chosenIcon = <CardStrikethrough fontSize="inherit" />;
            break;
        case 'UNBLOCK':
            chosenIcon = <Card fontSize="inherit" />;
            break;
        case 'ACCEPTED':
            chosenIcon = <Card fontSize="inherit" />;
            break;
    }

    return chosenIcon;
};

export default TimelineItemIconFactory;
